import React, {Fragment, useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container, Row, Col} from 'react-bootstrap'
import {LoginPage, ActiveUsers,UserReports, HospitalData} from '../../components'
import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import {Link, Route,NavLink,useLocation,useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {getHospital, getLabels, getReports, uploadXML} from "../../actions";
import IndicatorsPage from "./Indicators/IndicatorsPage";



const UserDataPage = ({getReports,getLabels,getHospital}) => {
    useEffect(() => {
            getReports();
            getLabels();
            getHospital();
            },[])
    return (
        <IndicatorsPage>

            <UserReports/>

        </IndicatorsPage>
    )
};
const mapStateToProps = state => ({
    Basic: state.Basic,

});
export default connect(mapStateToProps, {getReports, getLabels, getHospital})(UserDataPage)
